import React from 'react'
import classnames from 'classnames'

import { parseQuery } from '../helpers/queryHelper'

const TablePagination = ({
  search,
  queryLength,
  totalPages,
  prevPageClick,
  onPageClick,
  nextPageClick,
}) => {
  const parsedSearch = parseQuery(search)
  const currentPage =
    (Number(parsedSearch.offset) / Number(parsedSearch.limit)) + 1 // prettier-ignore

  const arrayLevel =
    currentPage % 4 === 0 ? (currentPage / 4) - 1 : Math.floor(currentPage / 4) // prettier-ignore
  const pagesNumberArray = [1, 2, 3, 4, 5].map((number) => {
    const newPageNumber = number + (4 * arrayLevel) // prettier-ignore

    // using 'undefined' prevents the rendering of non-existent pages.
    return newPageNumber <= totalPages ? newPageNumber : undefined
  })

  // only add ellipsis last page shortcut if pagesNumberArray's end has not been reached.
  const AddEllipsisLastPageShortcut = () => {
    if (!pagesNumberArray.includes(undefined)) {
      return (
        <>
          <div className="index-table__ellipsis">...</div>
          <a
            key={totalPages}
            className="index-table__button"
            onClick={() => onPageClick(totalPages)}
          >
            {totalPages}
          </a>
        </>
      )
    }

    return <></>
  }

  return (
    <div className="index-table__button-row">
      <a
        data-testid="previousPageLink"
        onClick={prevPageClick}
        className={classnames(
          'index-table__button',
          'index-table__button--previous',
          'icon-arrow',
          {
            'index-table__button--disabled':
              parsedSearch.limit > parsedSearch.offset,
          }
        )}
      />
      <div className="index-table__buttons-pages">
        {pagesNumberArray.map((pageNumber) => {
          // do not render undefined pageNumbers.
          if (typeof pageNumber === 'number') {
            if (pageNumber === currentPage) {
              return (
                <div key={pageNumber} className="index-table__active-page">
                  <span
                    key={pageNumber}
                    className="index-table__active-page__number"
                  >
                    {pageNumber}
                  </span>
                </div>
              )
            }

            return (
              <a
                data-testid="selectPageLink"
                key={pageNumber}
                className="index-table__button"
                onClick={() => onPageClick(pageNumber)}
              >
                {pageNumber}
              </a>
            )
          }

          return null
        })}
        <AddEllipsisLastPageShortcut />
      </div>
      <a
        data-testid="nextPageLink"
        onClick={nextPageClick}
        className={classnames(
          'index-table__button',
          'index-table__button--next',
          'icon-arrow',
          {
            'index-table__button--disabled': queryLength < parsedSearch.limit,
          }
        )}
      />
    </div>
  )
}

export default TablePagination
